/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Appearance_Language_HintInputs */

const en_settings_v2_appearance_language_hint = /** @type {(inputs: Settings_V2_Appearance_Language_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme, language, and library order`)
};

const es_settings_v2_appearance_language_hint = /** @type {(inputs: Settings_V2_Appearance_Language_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema, idioma y orden de la biblioteca`)
};

/**
* | output |
* | --- |
* | "Theme, language, and library order" |
*
* @param {Settings_V2_Appearance_Language_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_appearance_language_hint = /** @type {((inputs?: Settings_V2_Appearance_Language_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Appearance_Language_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_appearance_language_hint(inputs)
	return en_settings_v2_appearance_language_hint(inputs)
});